import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedComponent } from './shared.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { ErrorComponent } from './error/error.component';
import { DonorSidebarComponent } from './donor-sidebar/donor-sidebar.component';
import { MatIconModule } from '@angular/material/icon';
import { TopToolbarComponent } from './donorTopBar/top-toolbar/top-toolbar.component';
// import { PhotoviewerComponent } from './photoviewer/photoviewer.component';
// import { ImageViewerModule } from 'ng2-image-viewer';

@NgModule({
  declarations: [SharedComponent, SidebarComponent, ConfirmationDialogComponent, ErrorComponent, DonorSidebarComponent, TopToolbarComponent],
  imports: [
    // ImageViewerModule.forRoot(),
    CommonModule,
    AppRoutingModule, NgbModule, NgMultiSelectDropDownModule.forRoot(), ReactiveFormsModule,
    MatNativeDateModule, MatExpansionModule, MatIconModule
  ],

  exports: [SidebarComponent, DonorSidebarComponent, TopToolbarComponent]
})
export class SharedModule { }
